/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react'

import CreatableSelect from 'react-select/creatable'

import s from './CreatableSelect.module.css'

const customStyles = {
  control: (provided) => ({
    ...provided,
    border: '1px solid #404040',
    borderRadius: '5px',
    padding: '6px 8px',
    backgroundColor: '#171717',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#2D2D2D',
    color: '#fff',
    borderRadius: '200px',
    padding: '0 8px',
    alignItems: 'center',
    gap: '10px',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#fff',
    fontSize: '12px',
    lineHeight: '32px',
  }),
  container: (provided) => ({
    ...provided,
    padding: '0',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0',
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    'width': '16px',
    'height': '16px',
    'backgroundColor': state.isFocused ? '#D9D9D9' : 'transparent',
    'color': 'white',
    'borderRadius': '50%',
    'border': 'solid 1px #fff',
    'paddingLeft': '0',
    'paddingRight': '0',
    ':hover': {
      backgroundColor: '#D9D9D9',
      color: '#2D2D2D',
      border: 'solid 1px #D9D9D9',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#171717',
    color: '#fff',
    border: '1px solid #404040',
    borderRadius: '5px',
    padding: '6px 8px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#fff',
    fontSize: '12px',
    lineHeight: '32px',
  }),
  option: (provided) => ({
    ...provided,
    padding: '6px 8px',
    backgroundColor: '#171717',
    color: '#fff',
  }),
}

export function Select({ options, initialValues, onChange, placeholder }) {
  const [selectedOptions, setSelectedOptions] = useState(initialValues?.map((value) => ({ value, label: value })))

  useEffect(() => {
    const values = initialValues?.map((value) => ({ value, label: value }))

    setSelectedOptions(values)
  }, [initialValues])

  const handleChange = (selected) => {
    setSelectedOptions(selected || [])
    if (onChange) {
      onChange(selected ? selected.map((item) => item.value) : [])
    }
  }

  return (
    <CreatableSelect
      className={s.root}
      isMulti
      options={options?.map((option) => ({ value: option, label: option }))}
      value={selectedOptions}
      onChange={handleChange}
      placeholder={placeholder}
      styles={customStyles}
    />
  )
}
